import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import useChatContext from '../../hooks/useChatContext/useChatContext';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import useSessionContext from '../useSessionContext/useSessionContext';
import SessionWindowHeader from './SessionWindowHeader/SessionWindowHeader';
import SessionGoalDetails from './SessioinGoal/SessionGoalDetails';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chatWindowContainer: {
      background: '#FFFFFF',
      zIndex: 9,
      display: 'flex',
      flexDirection: 'column',
      borderLeft: '1px solid #E4E7E9',
      borderRadius: '12px',
      [theme.breakpoints.down('sm')]: {
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        zIndex: 100,
      },
    },
    hide: {
      display: 'none',
    },
  })
);

// In this component, we are toggling the visibility of the ChatWindow with CSS instead of
// conditionally rendering the component in the DOM. This is done so that the ChatWindow is
// not unmounted while a file upload is in progress.

export default function SessionWindow() {
  const classes = useStyles();
  const { isChatWindowOpen, setIsChatWindowOpen } = useChatContext();
  const { isBackgroundSelectionOpen, setIsBackgroundSelectionOpen } = useVideoContext();
  const { isSessionWindowOpen } = useSessionContext();

  return (
    <aside className={clsx(classes.chatWindowContainer, { [classes.hide]: !isSessionWindowOpen })}>
      <SessionWindowHeader />
      <SessionGoalDetails />
    </aside>
  );
}
